var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E8F3FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(10 9)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3594_124851)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(14 13)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3594_124851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2928 13.2921C14.4803 13.1046 14.7346 12.9993 14.9998 12.9993C15.265 12.9993 15.5193 13.1046 15.7068 13.2921L21.9998 19.5851L28.2928 13.2921C28.385 13.1966 28.4954 13.1204 28.6174 13.068C28.7394 13.0156 28.8706 12.988 29.0034 12.9869C29.1362 12.9857 29.2678 13.011 29.3907 13.0613C29.5136 13.1116 29.6253 13.1858 29.7192 13.2797C29.8131 13.3736 29.8873 13.4853 29.9376 13.6082C29.9879 13.731 30.0132 13.8627 30.012 13.9955C30.0109 14.1283 29.9833 14.2595 29.9309 14.3815C29.8785 14.5035 29.8023 14.6139 29.7068 14.7061L23.4138 20.9991L29.7068 27.2921C29.8889 27.4807 29.9897 27.7333 29.9875 27.9955C29.9852 28.2577 29.88 28.5085 29.6946 28.6939C29.5092 28.8793 29.2584 28.9845 28.9962 28.9868C28.734 28.9891 28.4814 28.8883 28.2928 28.7061L21.9998 22.4131L15.7068 28.7061C15.5182 28.8883 15.2656 28.9891 15.0034 28.9868C14.7412 28.9845 14.4904 28.8793 14.305 28.6939C14.1196 28.5085 14.0144 28.2577 14.0121 27.9955C14.0098 27.7333 14.1106 27.4807 14.2928 27.2921L20.5858 20.9991L14.2928 14.7061C14.1053 14.5186 14 14.2643 14 13.9991C14 13.7339 14.1053 13.4796 14.2928 13.2921Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3594_124851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3594_124851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9c77c6e945038fb0a41d5909261d0b39.svg";
export { ForwardRef as ReactComponent };